import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { formatDate } from "../utils/formatDate";

const useDownloadChart = (expandedArch=null, setExpandedArch=null, reportData=null) => {
  const downloadChart = async (elementId, chartTitle, filters = {}) => {
    const chartElement = document.getElementById(elementId);
    if (!chartElement) return;

    // --- Filters / Labels ---
    const archSelect = document.getElementById("archdeaconry");
    const parishSelect = document.getElementById("parish");
    const congSelect = document.getElementById("congregation");

    const archName = archSelect?.selectedOptions?.[0]?.text || "All Archdeaconries";
    const parishName = parishSelect?.selectedOptions?.[0]?.text || "All Parishes";
    const congName = congSelect?.selectedOptions?.[0]?.text || "All Congregations";

    const dateRange = `FROM-${formatDate(filters?.start_date || "01 JAN 2024")} TO-${formatDate(
      filters?.end_date || new Date()
    )}`;

    const fullTitle = `${chartTitle} | ${archName} | ${parishName} | ${congName} | ${dateRange}`.toUpperCase();
    const fileName = fullTitle.replace(/[^\w\s-]/g, "").replace(/\s+/g, "_");

    try {
      let previousState;

      if (expandedArch !== null && setExpandedArch !== null && reportData !== null) {
        // --- Expand ALL archdeaconries ---
        let previousState = { ...(expandedArch || {}) };
        const allExpanded = {};

        reportData?.data?.forEach(period => {
          period.breakdown.forEach(a => {
            allExpanded[`${period.period}-${a.archdeaconry}`] = true;
          });
        });

        setExpandedArch(allExpanded);

        // Wait for the DOM to update
        await new Promise(res => setTimeout(res, 500));
      }

      // --- Capture entire chart DOM ---
      const canvas = await html2canvas(chartElement, {
        scale: 2,
        useCORS: true,
      });

      const imgWidth = 290; // landscape
      const pageHeight = 200;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let yOffset = 0;

      const pdf = new jsPDF("landscape");
      pdf.setFontSize(12);
      pdf.text(fullTitle, 10, 10);

      // --- MULTI-PAGE FIX: Proper slicing of long canvas ---
      while (yOffset < imgHeight) {
        const canvasSlice = document.createElement("canvas");
        const ctx = canvasSlice.getContext("2d");

        canvasSlice.width = canvas.width;
        canvasSlice.height = (pageHeight * canvas.width) / imgWidth;

        // Slice the correct region from the big canvas
        ctx.drawImage(
          canvas,
          0,
          (yOffset * canvas.width) / imgWidth,
          canvas.width,
          (pageHeight * canvas.width) / imgWidth,
          0,
          0,
          canvas.width,
          (pageHeight * canvas.width) / imgWidth
        );

        const imgPage = canvasSlice.toDataURL("image/png");

        if (yOffset > 0) {
          pdf.addPage("landscape");
          pdf.text(fullTitle, 10, 10);
        }

        pdf.addImage(imgPage, "PNG", 0, 20, imgWidth, pageHeight - 20);

        yOffset += pageHeight;
      }

      // --- Save PDF ---
      pdf.save(`${fileName}.pdf`);

      if(expandedArch !== null && setExpandedArch !== null && reportData !== null) {
        // --- Restore previous expand state ---
        setExpandedArch(previousState);
      }
    } catch (error) {
      console.error("Chart download failed:", error);
    }
  };

  return { downloadChart };
};

export default useDownloadChart;
